import { render, staticRenderFns } from "./message-thread.vue?vue&type=template&id=e351088e"
import script from "./message-thread.vue?vue&type=script&lang=js"
export * from "./message-thread.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports